import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { DataService } from 'app/shared/services/data/data.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-reset-password-send',
  templateUrl: './reset-password-send.component.html',
  styleUrls: ['./reset-password-send.component.scss']
})
export class ResetPasswordSendComponent extends SubscriptionBaseComponent implements OnInit {

  faPaperPlane = faPaperPlane;

  email: string;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.redirection();

  }

  private redirection(): void {
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 6500);
  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.email.asObservable().subscribe(email => {
        this.email = email;
        this.cdr.detectChanges();
      })
    );
  }
}
